export function LoadingBlock() {
  return (
    <div className="loading-grid" aria-label="加载中">
      <span />
      <span />
      <span />
    </div>
  );
}
